import { Injectable } from '@angular/core'

@Injectable()
export class AppLoaderLocalizeService {
  getLoaderTitle(status: string): string {
    switch (status) {
      case 'retrieving':
        return $localize`:Loader Title|Text indicating the current loading state when retrieving a story@@Stories4313c62081a240dc99602a3798baf90b:Retrieving story`
      case 'looking':
        return $localize`:Loader Title|Text indicating the current loading state when looking for ancestors@@Stories244ef4b319a1466ea6e3d2186ef8e745:Looking for your ancestors...`
      case 'retrievingStories':
        return $localize`:Loader Title|Text indicating the current loading state when retrieving stories@@Storiese6d48562ab35486c8666dbc3f60a2491:Retrieving your Stories`
      default:
        return ''
    }
  }
}
